export const EmptyState = ({ message }: { message: string }) => <div className="p-8 text-center text-on-surface-variant">{message}</div>;